module.exports = __webpack_public_path__ + "img/zhongqiyanlogo.221f7fe2.png";